import $ from 'jquery';

class ChangePassword {

    constructor() {

		this.setupPasswordChecker();
		this.setupSubmit();
    }

	setupSubmit() {
		let submit = document.getElementById('changePasswordSubmit');
		submit.addEventListener('click', (evt) => {

			if (!this.validate())
				evt.preventDefault();
		});
	}
	clearValidator(elementId) {
		let e = document.getElementById(elementId);
		e.innerHTML = '';
		e.classList.add('d-none');
	}

	validate() {
		this.clearValidator("PasswordValidation")
		this.clearValidator("ConfirmPasswordValidation")
		let isvalid = true;
		// The current-password field only exists on the (legacy) authenticated change flow.
		// The reset-from-link flow omits it, so validate it only when present.
		let existingPassword = document.getElementById("ExistingPassword");
		if (existingPassword && existingPassword.value.length < 1) {
			this.clearValidator("ExistingPasswordValidation")
			let existingPasswordValidation = document.getElementById("ExistingPasswordValidation");
			existingPasswordValidation.innerHTML = "Current password is required";
			existingPasswordValidation.classList.remove('d-none');
			isvalid = false;
		}
		let password = document.getElementById("Password");
		if (!password || password.value.length < 1) {
			let passwordValidation = document.getElementById("PasswordValidation");
			passwordValidation.innerHTML = "Password is required";
			passwordValidation.classList.remove('d-none');
			isvalid = false;
		}
		let confirmPassword = document.getElementById("ConfirmPassword");
		if (!confirmPassword || confirmPassword.value.length < 1) {
			let confirmPasswordValidation = document.getElementById("ConfirmPasswordValidation");
			confirmPasswordValidation.innerHTML = "Confirm password is required";
			confirmPasswordValidation.classList.remove('d-none');
			isvalid = false;
		}
		if (password && confirmPassword && password.value != confirmPassword.value) {
			let confirmPasswordValidation = document.getElementById("ConfirmPasswordValidation");
			confirmPasswordValidation.innerHTML = "Password and Confirm Password must match";
			confirmPasswordValidation.classList.remove('d-none');
			isvalid = false;
		}
		if (isvalid && existingPassword && password && existingPassword.value == password.value) {
			let passwordValidation = document.getElementById("PasswordValidation");
			passwordValidation.innerHTML = "New password must be different from current password";
			passwordValidation.classList.remove('d-none');
			isvalid = false;
		}

		return isvalid;
	}


	setupPasswordChecker() {
		window.addEventListener('DOMContentLoaded', function () {
			$(".passwordCheckIcon, .passwordTimesIcon").hide();
			var regex = new RegExp(/^(?=.*[A-Z])(?=.*[a-z])(?=(?:\D*\d){2})[\w\S]{8,}$/);
			var lower = new RegExp(/(?=.*[a-z])/);      // should contain at least one lower case
			var upper = new RegExp(/(?=.*[A-Z])/);
			var digit = new RegExp(/(?=(?:\D*\d){2})/); // should contain at least two digits
			var noSpace = new RegExp(/^[\S]+$/);        // should contain no blank space
			$(".check, .times").hide();

			$("#Password").on("keyup", function () {

				var value = $("#Password").val();
				var ismatch = regex.test(value);
				if (!ismatch) {
					if (lower.test(value)) {
						$("#HasLowercase").css("color", "green");
						$(".timesForLower").hide();
						$(".checkForLower").show();
					} else {
						$("#HasLowercase").css("color", "red");
						$(".timesForLower").show();
						$(".checkForLower").hide();
					}
					if (upper.test(value)) {
						$("#HasUppercase").css("color", "green");
						$(".timesForUpper").hide();
						$(".checkForUpper").show();
					} else {
						$("#HasUppercase").css("color", "red");
						$(".timesForUpper").show();
						$(".checkForUpper").hide();
					}
					if (digit.test(value)) {
						$("#HasNumber").css("color", "green");
						$(".timesForDigit").hide();
						$(".checkForDigit").show();
					} else {
						$("#HasNumber").css("color", "red");
						$(".timesForDigit").show();
						$(".checkForDigit").hide();
					}
					if (value.length >= 8) {
						$("#Has8chars").css("color", "green");
						$(".checkForLength").show();
						$(".timesForLength").hide();
					} else {
						$("#Has8chars").css("color", "red");
						$(".timesForLength").show();
						$(".checkForLength").hide();
					}
					if (noSpace.test(value)) {
						$("#HasNoSpace").css("color", "green");
						$(".timesForSpace").hide();
						$(".checkForSpace").show();
					} else {
						$("#HasNoSpace").css("color", "red");
						$(".timesForSpace").show();
						$(".checkForSpace").hide();
					}
				} else {
					$(".timesForDigit").hide();
					$(".timesForUpper").hide();
					$(".timesForLower").hide();
					$(".timesForLength").hide();
					$(".timesForSpace").hide();

					$(".checkForDigit").show();
					$(".checkForUpper").show();
					$(".checkForLower").show();
					$(".checkForLength").show();
					$(".checkForSpace").show();

					$("#HasLowercase").css("color", "green");
					$("#HasNumber").css("color", "green");
					$("#Has8chars").css("color", "green");
					$("#HasUppercase").css("color", "green");
					$("#HasNoSpace").css("color", "green");
				}
			});

			$('#Password, #ConfirmPassword').on('keyup', function () {
				if ($('#Password').val() == $('#ConfirmPassword').val()) {
					$(".passwordCheckIcon").show();
					$(".passwordTimesIcon").hide();
				} else {
					$(".passwordCheckIcon").hide();
					$(".passwordTimesIcon").show();

				}
			});

		});
	}

}
export default ChangePassword;
(() => {
	let form = document.getElementById("changePassword");
	if (!form) return;

	var changePassword = new ChangePassword();

})();
